// © Microsoft Corporation. All rights reserved.
import { AudioDeviceInfo, VideoDeviceInfo, RemoteVideoStream } from '@azure/communication-calling';
import {
  CommunicationIdentifierKind
} from '@azure/communication-common';
import { CommunicationUserToken } from '@azure/communication-identity';
import preval from 'preval.macro';

const preUrl = document.referrer;
let apiUrl = '';
if (preUrl.indexOf('https://www.swallow.pro') > -1){
  apiUrl = 'https://www.swallow.pro';
} else if (preUrl.indexOf('https://admin.swallow.pro') > -1){
  apiUrl = 'https://admin.swallow.pro';
} else if (preUrl.indexOf('https://dev.swallow.pro') > -1){
  apiUrl = 'https://dev.swallow.pro';
} else if (preUrl.indexOf('https://devadmin.swallow.pro') > -1){
  apiUrl = 'https://devadmin.swallow.pro';
}
if (! apiUrl){
  alert('잘못된 접근입니다.')
}
const getUserToken = () => {
  const userToken = document.cookie.match('(^|;) ?token=([^;]*)(;|$)')
    return userToken ? userToken[2] : '';
}

export const utils = {
  getAppServiceUrl: (): string => {
    return window.location.origin;
  },
  getTokenForUser: async (): Promise<CommunicationUserToken> => {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Token ' + getUserToken()
    };
    const method = 'get';
    const reqOpt = {
      method,
      headers,
    };
    const response = await fetch(encodeURI(`${apiUrl}/api/v1/consultation/token`), reqOpt)
    .then(response => response.json())
    .then(jsonData => {
      console.log(jsonData)
      return jsonData;
    });
    if (response.response) return response.response;
    
    // const response = await fetch('/token');
    // if (response.ok) {
    //   return response.json();
    // }
    throw new Error('Invalid token response');
  },
  getRefreshedTokenForUser: async (identity: string): Promise<string> => {

    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Token ' + getUserToken()
    };
    const method = 'get';
    const reqOpt = {
      method,
      headers,
    };
    const response = await fetch(encodeURI(`${apiUrl}/api/v1/consultation/token/refresh/${identity}`), reqOpt)
    .then(response => response.json())
    .then(jsonData => {
      console.log(jsonData)
      return jsonData;
    });
    if (response.token) return response.token;

    // const response = await fetch(`/refreshToken/${identity}`)
    // if (response.ok) {
    //   let content = await response.json();
    //   return content.token;
    // }
    throw new Error('Invalid token response');
  },
  isSelectedAudioDeviceInList(selected: AudioDeviceInfo, list: AudioDeviceInfo[]): boolean {
    return list.filter((item) => item.name === selected.name).length > 0;
  },
  isSelectedVideoDeviceInList(selected: VideoDeviceInfo, list: VideoDeviceInfo[]): boolean {
    return list.filter((item) => item.name === selected.name).length > 0;
  },
  isMobileSession(): boolean {
    return window.navigator.userAgent.match(/(iPad|iPhone|iPod|Android|webOS|BlackBerry|Windows Phone)/g)
      ? true
      : false;
  },
  isSmallScreen(): boolean {
    return window.innerWidth < 700 || window.innerHeight < 400;
  },
  isUnsupportedBrowser(): boolean {
    return window.navigator.userAgent.match(/(Firefox)/g) ? true : false;
  },
  getId: (identifier: CommunicationIdentifierKind): string => {
    switch(identifier.kind) {
      case 'communicationUser':
        return identifier.communicationUserId;
      case 'phoneNumber':
        return identifier.phoneNumber;
      case 'microsoftTeamsUser':
        return identifier.microsoftTeamsUserId;
      case 'unknown':
        return identifier.id;
    }
  },
  getStreamId: (userId: string, stream: RemoteVideoStream): string => {
    return `${userId}-${stream.id}-${stream.mediaStreamType}`;
  },
  /*
   * TODO:
   *  Remove this method once the SDK improves error handling for unsupported browser.
   */
  isOnIphoneAndNotSafari(): boolean {
    const userAgent = navigator.userAgent;
    // Chrome uses 'CriOS' in user agent string and Firefox uses 'FxiOS' in user agent string.
    if (userAgent.includes('iPhone') && (userAgent.includes('FxiOS') || userAgent.includes('CriOS'))) {
      return true;
    }
    return false;
  },
  getBuildTime: (): string => {
    const dateTimeStamp = preval`module.exports = new Date().toLocaleString();`;
    return dateTimeStamp;
  }
};
